<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section">
        <div class="container-fluid">
          <div class="grid justify-content-between">
            <div class="col">
              <div class="">
                <div class="text-3xl font-bold">Add New Office(s)</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr />
    </template>
    <section class="page-section pt-3">
      <div class="container-fluid">
        <div class="grid">
          <div class="md:col-9 sm:col-12 comp-grid">
            <div class="">
              <div class="">
                <div>
                  <form
                    ref="observer"
                    tag="form"
                    @submit.prevent="submitForm()"
                    class=""
                    :class="{ card: !isSubPage }"
                  >
                    <div>
                      <table class="p-datatable-table w-full">
                        <tbody>
                          <tr
                            v-for="(formData, row) in arrFormData"
                            :key="row"
                            class="input-row"
                          >
                            <div class="card nice-shadow-6 mr-1">
                              <div class="grid">
                                <div class="col-12 md:col-6">
                                  <div class="mb-2 font-bold text-sm">
                                    Region *
                                  </div>
                                  <div class="">
                                    <api-data-source
                                      api-path="components_data/region_option_list"
                                    >
                                      <template v-slot="req">
                                        <Dropdown
                                          class="w-full"
                                          :editable="false"
                                          :class="getErrorClass('region', row)"
                                          :loading="req.loading"
                                          optionLabel="label"
                                          optionValue="value"
                                          ref="ctrlregion"
                                          v-model="formData.region"
                                          :options="req.response"
                                          label="Region"
                                          placeholder="Select ..."
                                          :filter="true"
                                        >
                                        </Dropdown>
                                        <small
                                          v-if="isFieldValid('region', row)"
                                          class="p-error"
                                          >{{
                                            getFieldError("region", row)
                                          }}</small
                                        >
                                      </template>
                                    </api-data-source>
                                  </div>
                                </div>
                                <div class="col-12 md:col-6">
                                  <div class="mb-2 font-bold text-sm">
                                    District *
                                  </div>
                                  <div class="">
                                    <api-data-source
                                      @loaded="formData.district = ''"
                                      :load-on-mount="false"
                                      :api-path="`components_data/district_option_list?lookup_region=${formData.region}`"
                                    >
                                      <template v-slot="req">
                                        <Dropdown
                                          class="w-full"
                                          :editable="false"
                                          :class="
                                            getErrorClass('district', row)
                                          "
                                          :loading="req.loading"
                                          optionLabel="label"
                                          optionValue="value"
                                          ref="ctrldistrict"
                                          v-model="formData.district"
                                          :options="req.response"
                                          label="District"
                                          placeholder="Select ..."
                                        >
                                        </Dropdown>
                                        <small
                                          v-if="isFieldValid('district', row)"
                                          class="p-error"
                                          >{{
                                            getFieldError("district", row)
                                          }}</small
                                        >
                                      </template>
                                    </api-data-source>
                                  </div>
                                </div>
                                <div class="col-12 md:col-12">
                                  <div class="mb-2 font-bold text-sm">
                                    Name of Office *
                                  </div>
                                  <div class="">
                                    <check-duplicate
                                      v-model="formData.name"
                                      check-path="components_data/offices_name_exist/"
                                      v-slot="checker"
                                    >
                                      <InputText
                                        ref="ctrlname"
                                        @blur="checker.check"
                                        :loading="checker.loading"
                                        v-model.trim="formData.name"
                                        label="Name of Office"
                                        type="text"
                                        placeholder="Enter Name of Office"
                                        class="w-full"
                                        :class="getErrorClass('name', row)"
                                      >
                                      </InputText>
                                      <small
                                        v-if="isFieldValid('name', row)"
                                        class="p-error"
                                        >{{ getFieldError("name", row) }}</small
                                      >
                                      <small
                                        v-if="!checker.loading && checker.exist"
                                        class="p-error"
                                      >
                                        Name already exists</small
                                      >
                                      <small
                                        v-if="checker.loading"
                                        class="text-500"
                                        >Checking...</small
                                      >
                                    </check-duplicate>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <th>
                              <Button
                                class="p-button-outlined p-button-sm p-button-danger p-button-rounded"
                                v-if="arrFormData.length > minRowCount"
                                @click="removeFormRow(row)"
                                icon="pi pi-times"
                              />
                            </th>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td colspan="100" class="text-right">
                              <Button
                                v-if="arrFormData.length < maxRowCount"
                                label="Add Another Office"
                                @click="addFormRow()"
                                icon="pi pi-plus"
                                class="p-button-outlined p-button-sm p-button-rounded"
                              />
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                    <hr />
                    <div v-if="showSubmitButton" class="text-center q-my-md">
                      <Button
                        type="submit"
                        label="Submit Form"
                        icon="pi pi-send"
                        class="p-button-rounded"
                        :loading="saving"
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { computed, reactive, toRefs, onMounted } from "vue";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@/services/validators";
import { useApp } from "@/composables/app.js";
import { useAddPage } from "@/composables/addpage.js";
//[--PAGE-IMPORT-STATEMENT--]
const props = defineProps({
  pageName: {
    type: String,
    default: "offices",
  },
  routeName: {
    type: String,
    default: "officesadd",
  },
  apiPath: {
    type: String,
    default: "offices/add",
  },
  submitButtonLabel: {
    type: String,
    default: "Submit",
  },
  formValidationError: {
    type: String,
    default: "Form is invalid",
  },
  formValidationMsg: {
    type: String,
    default: "Please complete the form",
  },
  msgAfterSave: {
    type: String,
    default: "Record added successfully",
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showSubmitButton: {
    type: Boolean,
    default: true,
  },
  redirect: {
    type: Boolean,
    default: true,
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
  maxRowCount: {
    type: Number,
    default: 10,
  },
  minRowCount: {
    type: Number,
    default: 1,
  },
});
const app = useApp();
const formDefaultValues = {
  region: "",
  district: "",
  name: "",
};
let arrFormData = reactive([{ ...formDefaultValues }]);
//validation rules
const rules = computed(() => {
  return {
    $each: helpers.forEach({
      region: { required },
      district: { required },
      name: {},
    }),
  };
});
const v$ = useVuelidate(rules, arrFormData); // form validation
const page = useAddPage({
  props,
  formData: arrFormData,
  v$,
  beforeSubmit,
  afterSubmit,
});
// perform custom validation before submit form
// set custom form fields
// return false if validation fails
function beforeSubmit() {
  return true;
}
function afterSubmit(response) {
  app.flashMsg(props.msgAfterSave);
  page.setFormDefaultValues(); // reset form data
  if (props.redirect) app.navigateTo(`/offices`);
}
function addFormRow() {
  arrFormData.push({ ...formDefaultValues });
}
function removeFormRow(index) {
  arrFormData.splice(index, 1);
}
//page state
const {
  submitted, // form api submitted state - Boolean
  saving, // form api submiting state - Boolean
  pageReady, // if api data loaded successfully
} = toRefs(page.state);
//page methods
const {
  submitForm, // submit form data to api
  getErrorClass, // return error class if field is invalid- args(fieldname, index)
  getFieldError, //  get validation error message - args(fieldname, index)
  isFieldValid, // check if field is validated - args(fieldname)
  // map api datasource  to Select options label-value
} = page.methods;
onMounted(() => {
  const pageTitle = "Add New Office";
  app.setPageTitle(props.routeName, pageTitle); // set browser page title
});
// expose page object for other components access
defineExpose({
  page,
});
</script>
<style scoped></style>
<style scoped></style>
